/*eslint-disable*/
module.exports =  {
    locales: [
        'en',
        'ru',
        'bg',
        'uk',
        'fr',
        'lv',
        'es',
    ],
    localeNames: {
        en: 'English',
        ru: 'Русский',
        bg: 'Български',
        uk: 'Український',
        fr: 'Français',
        lv: 'Latviešu',
        es: 'Español'
    }
}
